import { NoSymbolIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { renderLinks } from '../../../../Check-In/utils';

interface CheckInCardProps {
  description?: string;
  blockers?: string[];
  wipLinks?: string;
  className?: string;
}

export function CheckInCard({
  description,
  blockers,
  wipLinks,
  className = '',
}: CheckInCardProps): JSX.Element {
  return (
    <div
      className={`ml-6 mt-2 bg-white border border-gray-200 rounded-lg p-4 text-sm text-gray-700 shadow-sm ${className}`}
    >
      {description && <div>{description}</div>}
      {blockers && blockers.length > 0 && (
        <div className="mt-2">
          <p className="flex items-center gap-1 text-[#8C8C8C] font-medium">
            <NoSymbolIcon className="w-4 h-4 text-red-500" />
            Blockers :
          </p>
          <div>{blockers.join(', ')}</div>
        </div>
      )}
      {wipLinks && (
        <div className="mt-2">
          <p className="text-[#8C8C8C] font-medium">WIP Materials :</p>
          <div>{renderLinks(wipLinks)}</div>
        </div>
      )}
    </div>
  );
}
